import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.scss'],
})
export class SlideToggleComponent implements OnChanges {
  @Input()
  public form: FormGroup;
  @Input() public isDisabled: boolean;
  @Input()
  public config: any = {};

  constructor() {}

  public ngOnChanges(changes: SimpleChanges): void {
    if ((changes['isDisabled'] || changes['form']) && this.form && this.config?.key) {
      const control = this.form.get(this.config.key);
      if (control) {
        this.isDisabled ? control.disable() : control.enable();
      }
    }
  }
}
